import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

type Props = {
  color?: string;
};

export const ProfileTabSvg: React.FC<Props> = ({color = '#111'}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={28}
      height={28}
      fill='none'
    >
      <g>
        <path
          fill={color}
          d='M23.9 4.1A13.908 13.908 0 0 0 14 0c-3.74 0-7.255 1.456-9.9 4.1A13.908 13.908 0 0 0 0 14c0 3.74 1.456 7.255 4.1 9.9A13.908 13.908 0 0 0 14 28c3.74 0 7.255-1.456 9.9-4.1A13.909 13.909 0 0 0 28 14c0-3.74-1.456-7.255-4.1-9.9ZM7.018 24.193A7.069 7.069 0 0 1 14 18.335a7.068 7.068 0 0 1 6.981 5.858A12.289 12.289 0 0 1 14 26.359c-2.589 0-4.994-.8-6.981-2.166Zm2.53-11.95A4.456 4.456 0 0 1 14 7.79a4.457 4.457 0 0 1 4.451 4.452A4.457 4.457 0 0 1 14 16.694a4.457 4.457 0 0 1-4.451-4.451Zm12.853 10.812a8.72 8.72 0 0 0-2.547-4.106 8.72 8.72 0 0 0-2.535-1.6 6.091 6.091 0 0 0 2.772-5.106A6.1 6.1 0 0 0 14 6.15a6.099 6.099 0 0 0-6.092 6.092 6.092 6.092 0 0 0 2.772 5.106 8.722 8.722 0 0 0-2.535 1.6 8.722 8.722 0 0 0-2.547 4.106A12.328 12.328 0 0 1 1.64 14C1.64 7.185 7.185 1.64 14 1.64S26.36 7.186 26.36 14c0 3.573-1.526 6.796-3.958 9.055Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path
            fill='#fff'
            d='M0 0h28v28H0z'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
